import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController, ViewController, AlertController } from 'ionic-angular'; 
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { CartserviceProvider } from '../../providers/cartservice';
import { CartProduct } from '../../providers/cartservice';
import { Storage } from '@ionic/storage';


@Component({
  selector: 'page-aufstellung',
  templateUrl: 'aufstellung.html',
})
export class AufstellungPage {
cartProductNumber = 0;
bezeichnung: string;
productname: string;
producttype: string;
windowtype: string;
typeopen: string
windowlong: string;
windowwide: string;
dekorfarbe: string;
dichtungen: string;
outColorIn: string;
outColorOut: string;
selectedGriffe: string;
selectedOrnament: any; 
selectedVerglasung: any; 
selectedKante: string;
selectedSprossentyp: any;
selectedSprossenmuster: any;
selectedSprossenfarbe: any;
selectedRahmenLinks: any;
selectedRahmenRechts: any;
selectedRahmenOben: any;
selectedRahmenUnten: any;
noInfo: string;


  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public appConfig: AppConfig, public cartService: CartserviceProvider, public loadingCtrl: LoadingController, public modalCtrl: ModalController, public viewCtrl : ViewController, public storage: Storage, public alertCtrl: AlertController )  {
  
    this.noInfo = "Keine Angaben";
  
    this.selectedRahmenLinks = this.navParams.get('selectedRahmenLinks');
    this.selectedRahmenRechts = this.navParams.get('selectedRahmenRechts');
    this.selectedRahmenOben = this.navParams.get('selectedRahmenOben'); 
    this.selectedRahmenUnten = this.navParams.get('selectedRahmenUnten');
    this.selectedSprossentyp = this.navParams.get('selectedSprossentyp');
    this.selectedSprossenmuster = this.navParams.get('selectedSprossenmuster');
    this.selectedSprossenfarbe = this.navParams.get('selectedSprossenfarbe');
    this.selectedOrnament = this.navParams.get('selectedOrnament');
    this.selectedVerglasung = this.navParams.get('selectedVerglasung');
    this.selectedKante = this.navParams.get('selectedKante');
    this.selectedGriffe = this.navParams.get('selectedGriffe');
    this.dichtungen = this.navParams.get('dichtungen');
    this.outColorIn = this.navParams.get('outColorIn');
    this.outColorOut = this.navParams.get('outColorOut');
    this.typeopen = this.navParams.get('typeopen');
    this.windowtype = this.navParams.get('windowtype');
    this.productname = this.navParams.get('productname');
    this.producttype = this.navParams.get('producttype');
    this.windowlong = this.navParams.get('windowlong');
    this.windowwide = this.navParams.get('windowwide');
    
      if (this.productname == null || this.productname == "undefined"){
  this.productname = this.noInfo;
  }
  if (this.producttype == null || this.producttype == "undefined"){
  this.producttype = this.noInfo;
  }
  if (this.windowtype == null || this.windowtype == "undefined"){
  this.windowtype = this.noInfo;
  }
  if (this.typeopen == null || this.typeopen == "undefined"){
  this.typeopen = this.noInfo;
  }
  if (this.windowlong == null || this.windowlong == "undefined"){
  this.windowlong = this.noInfo;
  }
  if (this.windowwide == null || this.windowwide == "undefined"){
  this.windowwide = this.noInfo;
  }
  if (this.dichtungen == null || this.dichtungen == "undefined"){
  this.dichtungen = this.noInfo;
  }
  if (this.outColorOut == null || this.outColorOut == "undefined"){
  this.outColorOut = this.noInfo;
  }
  if (this.outColorIn == null || this.outColorIn == "undefined"){
  this.outColorIn = this.noInfo;
  }
  if (this.dichtungen == null || this.dichtungen == "undefined"){
  this.dichtungen = this.noInfo;
  }
  if (this.selectedGriffe == null || this.selectedGriffe == "undefined"){
  this.selectedGriffe = this.noInfo;
  }
  if (this.selectedKante == null || this.selectedKante == "undefined"){
  this.selectedKante = this.noInfo;
  }
  if (this.selectedVerglasung == null || this.selectedVerglasung == "undefined"){
  this.selectedVerglasung = this.noInfo;
  }
  if (this.selectedOrnament == null || this.selectedOrnament == "undefined"){
  this.selectedOrnament = this.noInfo;
  }
  if (this.selectedSprossenfarbe == null || this.selectedSprossenfarbe == "undefined"){
  this.selectedSprossenfarbe = this.noInfo;
  }
  if (this.selectedSprossenmuster == null || this.selectedSprossenmuster == "undefined"){
  this.selectedSprossenmuster = this.noInfo;
  }
  if (this.selectedSprossentyp == null || this.selectedSprossentyp == "undefined"){
  this.selectedSprossentyp = this.noInfo;
  }
  if (this.selectedRahmenUnten == null || this.selectedRahmenUnten == "undefined"){
  this.selectedRahmenUnten = this.noInfo;
  }
  if (this.selectedRahmenOben == null || this.selectedRahmenOben == "undefined"){
  this.selectedRahmenOben = this.noInfo;
  }
  if (this.selectedRahmenRechts == null || this.selectedRahmenRechts == "undefined"){
  this.selectedRahmenRechts = this.noInfo;
  }
  if (this.selectedRahmenLinks == null || this.selectedRahmenLinks == "undefined"){
  this.selectedRahmenLinks = this.noInfo;
  }
  
    console.log( this.productname, this.producttype, this.windowtype, this.typeopen, this.windowlong, this.windowwide, this.outColorIn, this.outColorOut, this.selectedGriffe, this.selectedKante, this.selectedVerglasung, this.selectedOrnament, this.selectedSprossentyp, this.selectedSprossenfarbe, this.selectedSprossenmuster, this.selectedRahmenLinks, this.selectedRahmenRechts, this.selectedRahmenOben, this.selectedRahmenUnten); 
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AufstellungPage');
  }
  
  addToCart(){
var cartArray: Array<CartProduct> = new Array<CartProduct>();

const prompt = this.alertCtrl.create({
      title: 'Bezeichnung',
      message: "Geben Sie Ihrer Auswahl eine Bezeichnung. Zum Beispiel: Küche.",
      inputs: [
        {
          name: 'Bezeichnung',
          placeholder: 'z.B. Küche'
        },
      ],
      buttons: [
        {
          text: 'Löschen',
          handler: data => {
          }
        },
        { 
          text: 'Hinzufügen',
          handler: data => {
this.bezeichnung = data.Bezeichnung;

this.storage.get('MyProduct').then((data) => {
 if (data) {
cartArray = JSON.parse(data);
var findIndex = cartArray.findIndex((element) => {
   return element.bezeichnung == this.bezeichnung
 });
 if (findIndex != -1) {
     //cartArray[findIndex].quantity++;
     this.addToCartDuplicate();
  }
   else {
   cartArray.push(this.createNewProduct());
this.storage.set('MyProduct', JSON.stringify(cartArray));
this.cartService.cartBage = cartArray.length;
this.cartProductNumber = cartArray.length;
this.addToCartSuccessfully();
this.restoreData();
   }
   } else {
cartArray.push(this.createNewProduct());
this.storage.set('MyProduct', JSON.stringify(cartArray));
this.cartService.cartBage = cartArray.length;
this.cartProductNumber = cartArray.length;
this.addToCartSuccessfully();
this.restoreData();   
   }
   });
          }
        }
      ] 
    });
    prompt.present();  
  }
  
  
  
    createNewProduct() {
        var newProduct = new CartProduct();
newProduct.bezeichnung = this.bezeichnung;
newProduct.productname = this.productname;
newProduct.producttype = this.producttype;
newProduct.windowtype = this.windowtype;
newProduct.typeopen = this.typeopen;
newProduct.windowlong = this.windowlong;
newProduct.windowwide = this.windowwide;
newProduct.dichtungen = this.dichtungen;
newProduct.outColorIn = this.outColorIn;
newProduct.outColorOut = this.outColorOut;
newProduct.selectedGriffe = this.selectedGriffe;
newProduct.selectedOrnament = this.selectedOrnament;
newProduct.selectedVerglasung = this.selectedVerglasung;
newProduct.selectedKante = this.selectedKante;
newProduct.selectedSprossentyp = this.selectedSprossentyp;
newProduct.selectedSprossenmuster = this.selectedSprossenmuster;
newProduct.selectedSprossenfarbe = this.selectedSprossenfarbe;
newProduct.selectedRahmenLinks = this.selectedRahmenLinks;
newProduct.selectedRahmenRechts =this.selectedRahmenRechts;
newProduct.selectedRahmenOben = this.selectedRahmenOben;
newProduct.selectedRahmenUnten = this.selectedRahmenUnten;

        return newProduct;
    }
    
    
        ionViewWillEnter() {
        this.storage.get('MyProduct').then((data) => {
            if (data) {
                this.cartProductNumber = JSON.parse(data).length;
                console.log(this.cartProductNumber);
            }
          });
        }
        
  addToCartSuccessfully() {
    const alert = this.alertCtrl.create({
      title: 'Hurra!',
      subTitle: 'Dein konfiguriertes Fenster wurde zum Warenkorb hinzugefügt',
      buttons: ['OK']
    });
    alert.present();
  }
  
   addToCartDuplicate() {
    const alert = this.alertCtrl.create({
      title: 'Achtung!',
      subTitle: 'Diese Bezeichnung wurde schon einmal verwendet. Tippen Sie bitte eine andere Bezeichnung ein.',
      buttons: ['OK']
    });
    alert.present();
  }
  
  restoreData(){
this.bezeichnung = '';
this.productname = '';
this.producttype = '';
this.windowtype = '';
this.typeopen = ''; 
this.windowlong = '';
this.windowwide = '';
this.dichtungen = '';
this.dekorfarbe = '';
this.dichtungen = '';
this.outColorIn = '';
this.outColorOut = '';
this.selectedGriffe = '';
this.selectedOrnament = ''; 
this.selectedVerglasung = ''; 
this.selectedKante = '';
this.selectedSprossentyp = '';
this.selectedSprossenmuster = '';
this.selectedSprossenfarbe = '';
this.selectedRahmenLinks = '';
this.selectedRahmenRechts = '';
this.selectedRahmenOben = '';
this.selectedRahmenUnten = '';
this.navCtrl.parent.select(0);
  }
}



// WEBPACK FOOTER //
// ./src/pages/aufstellung/aufstellung.ts